module.exports = __webpack_public_path__ + "fec0c43390543a4888f932450f5ca9a6.MP3";